import { useState } from 'react';

// Components
import ReshipmentsTable from './ReshipmentsTable';
import OrderDetail from './OrderDetail';

export default function Reshipments({ device, setSessionMessage, history }) {
  const [orderSelected, setOrderSelected] = useState(null);
  const [blackList, setBlackList] = useState(false);

  return (
    <div>
      {(orderSelected && (
        <OrderDetail
          order={orderSelected}
          device={device}
          setSessionMessage={setSessionMessage}
          setOrderSelected={setOrderSelected}
          history={history}
          blackList={blackList}
        />
      )) || (
        <ReshipmentsTable
          device={device}
          setSessionMessage={setSessionMessage}
          setOrderSelected={setOrderSelected}
          setBlackList={setBlackList}
        />
      )}
    </div>
  );
}
